import styled from 'styled-components';
import mainColors from '../../../Style-guide/main-colors';
import sizeStandards from '../../../Style-guide/size-standards';

const FooterWrapper = styled.footer`
  height: 110px;
  background: ${mainColors.main_color_gradient};
  padding: 12px;
  display: flex;
  align-items: center;

  .footer-logo {
    background-color: ${mainColors.dark_background};
    border-radius: 80px;
    width: 90px;
    height: auto;
    fill: ${mainColors.main_color};

    @media only screen and (max-width: ${sizeStandards.screen.SM}px) {
      max-width: 72px;
      max-height: 72px;
    }
  }

  .footer-links-container {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;

    .footer-link {
      color: ${mainColors.text_color};
      text-decoration: none;
      border-radius: 12px;
      padding: 0 8px;
      text-align: center;

      &:hover {
        box-shadow: 0px 0px 10px 0px ${mainColors.text_color};
      }
    }
  }
`;

export default FooterWrapper;
